import { pick } from './util/utils';
import { getHeapCookie } from './heap';
import { EventNameTypes, DataLayerEventTypes, makeSegmentTrackCall, triggerDataLayer } from './analytics';
import { sha256 } from './util/krux';

// Whitelist analytics.identify properties:
export const WhitelistIdentifyKeys = ['name', 'email', 'phone'];

// Whitelist analytics.track('Form Submission') event properties
export const WhitelistFormKeys = [
  'contact_name',
  'company_size',
  'lead_source_detail',
  'lead_source',
  'heap_session_id',
  'heapUserId',
  'min_capacity',
  'experience',
  'timeframe',
  ...WhitelistIdentifyKeys
];

function createDataLayerEvents(formData) {
  const event = {
    // note: uuid used to be md5 in Quincy
    uuid: (formData.email_sha256 || '').substring(0, 32),
    email_sha256: formData.email_sha256,
    heapUserId: formData.heapUserId
  };
  const events = [
    // Generic lead submitted event:
    {
      event: DataLayerEventTypes.LEAD_SUBMISSION,
      ...event
    },
    // Specific form event:
    {
      event: formData.lead_source_detail,
      ...event
    }
  ];
  triggerDataLayer(events);
}

export async function sendLeadFormHeapEvents(formValues, leadSource, leadSourceSubtype) {
  const heapCookieId = global.GTMheapId || getHeapCookie();
  const props = {
    ...pick(formValues, WhitelistFormKeys),
    lead_source_detail: leadSource,
    lead_source: 'WeWork.com',
    heap_session_id: heapCookieId.sessionId,
    heapUserId: heapCookieId.userId,
    label: leadSource
  };

  if (!props.lead_source_subtype && leadSourceSubtype) {
    props.lead_source_subtype = leadSourceSubtype;
  }

  if (!props.company_size && formValues.desiredCapacity) {
    props.company_size = formValues.desiredCapacity;
  }

  if (formValues.moveInDate) {
    props.move_in_date = formValues.moveInDate;
  }

  if (formValues.email) {
    props.email_sha256 = await sha256(formValues.email);
  }

  if (formValues.hasVirtualTour !== undefined) {
    props.has_virtual_tour = formValues.hasVirtualTour;
  }

  if (formValues.callDates) {
    props.callDates = formValues.callDates;
  }

  if (formValues.callTimes) {
    props.callTimes = formValues.callTimes;
  }

  makeSegmentTrackCall(EventNameTypes.form, props);

  createDataLayerEvents(props);
  const { userId } = window.analyticsGlobals;

  const { contact_name: name, email, phone } = formValues;

  global.analytics.identify(
    userId,
    {
      name,
      email,
      phone
    },
    {
      integrations: {
        Heap: true
      }
    }
  );
}
